import styled from 'styled-components';
import { AppStyledProps } from '../../../../../../../types';
import { Props } from './types';
import { hexToRgb } from '@/components/util';

type T = Props & AppStyledProps;

export const RootStyled = styled.div<T>`
  position: absolute;
  z-index: 999;
  top: 20px;
  right: 250px;
  color: #ffffff;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  flex-direction: column;
  padding: 1.25em;
  justify-content: space-between;
  border-radius: 10px;
  max-width: 60%;
  min-width: 320px;
  min-height: 320px;

  ${({ background, opacity, color, withFooter, theme }) => {
    let styles = ``;
    if (!withFooter) {
      styles += 'justify-content: flex-start;';
    }
    if (background && opacity) {
      const { r, g, b } = hexToRgb(background);
      styles += `background-color: rgba(${r},${g},${b}, ${opacity});`;
    }
    if (color) {
      styles += `color: ${color};`;
    }
    if (theme.device.mobile) {
      styles += '';
    }
    return styles;
  }}
`;
